import DashboardLayout from 'components/DashboardLayout';
import Table from 'components/Table';
import React, { FC } from 'react';
import { RouteComponentProps } from 'react-router';
import { ReviewerPageViewModel } from './ReviewerPage.ViewModel';

const ReviewerPage: FC<RouteComponentProps> = () => {
  const vm = ReviewerPageViewModel();

  return (
    <div>
      <DashboardLayout>
        <Table
          title={vm.title}
          columns={vm.columns}
          data={vm.documents}
          hideFilterCheckbox
          // filter={vm.filter}
          // handleFilterChange={vm.handleFilterChange}
          setPage={vm.setPage}
          setLimit={vm.setLimit}
          pageNum={vm.page}
          count={vm.count}
          setStatus={vm.setStatus}
          disableButton
        />
      </DashboardLayout>
    </div>
  );
};

export default ReviewerPage;
